import { render, staticRenderFns } from "./operationLimitRelease.vue?vue&type=template&id=958d90aa&scoped=true"
import script from "./operationLimitRelease.vue?vue&type=script&lang=js"
export * from "./operationLimitRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958d90aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('958d90aa')) {
      api.createRecord('958d90aa', component.options)
    } else {
      api.reload('958d90aa', component.options)
    }
    module.hot.accept("./operationLimitRelease.vue?vue&type=template&id=958d90aa&scoped=true", function () {
      api.rerender('958d90aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/signLimitConfiguration/operationLimitRelease.vue"
export default component.exports